import {
  CardContainer,
  CardDetails,
  CardImage,
  CardName,
  CardPrice,
} from "./CardStyles";

const Card = ({ name, price, image }) => {
  return (
    <CardContainer>
      <CardImage>
        <img src={image} alt="Card" />
      </CardImage>
      {/* <CardDetails> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardName>{name}</CardName>
        <CardPrice>Ghc {price}</CardPrice>
        {/* </CardDetails> */}
      </div>
    </CardContainer>
  );
};

export default Card;
